import { backendUrl } from '../../../tools/env';

/**
 * Mystery Client files are always fetched through the authenticated Traffix API,
 * which checks the caller's access to the requested client before proxying uploads.
 */
export const getClientFileUrl = (filePath) => {
  const cleanPath = filePath.startsWith('/') ? filePath.slice(1) : filePath;
  return backendUrl(`/api/mystery-client/files/${cleanPath}`);
};
